import { render, staticRenderFns } from "./organization.vue?vue&type=template&id=13b91cf4&scoped=true"
import script from "./organization?vue&type=script&lang=js&external"
export * from "./organization?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b91cf4",
  null
  
)

export default component.exports